export default __webpack_public_path__ + "static/media/etown-central-logo.aed7dfc6.png";